import { dcFactory } from '@deleteagency/dc';
import CustomActivityLoggerSearch from './js/custom-activity-logger-search.component';

dcFactory.register(CustomActivityLoggerSearch);
